import Layout from "../../components/Layout";
import BookingSummary from "../../components/BookingSummary";
import BookingNavigation from "../../components/BookingNavigation";
import BookingForm from "./components/BookingForm";
import { Heading, TextLink } from "@/components/typography";
import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";
import { TalentStep } from "./components/TalentStep";
import { useNewBooking } from "./useNewBooking";

export default function NewBooking() {
    const page = useNewBooking();

    return (
        <Layout gray={true}>
            {/* Main list/form column + sticky summary sidebar */}
            <div className="flex">
                <Dialog open={page.creed.open} onOpenChange={page.creed.onOpenChange}>
                    <DialogContent className="sm:max-w-md" showCloseButton={false}>
                        <DialogHeader>
                            <DialogTitle render={<Heading type="h3" tag="h2" />}>
                                Creed Discount Reminder
                            </DialogTitle>
                            <DialogDescription className="text-foreground">
                                Remember to log the booking price for this deal as the &quot;post-discount&quot; rate (taking into account the 5% discount agreed on Creed deals).
                            </DialogDescription>
                        </DialogHeader>
                        <DialogFooter>
                            <Button onClick={() => page.creed.onOpenChange(false)}>
                                Okay!
                            </Button>
                        </DialogFooter>
                    </DialogContent>
                </Dialog>

                <div className="w-full p-4 pb-12 lg:flex-[0_0_70%]">

                    {page.step === "list" ? (
                        <TalentStep
                            campaignConstraints={page.campaignConstraints}
                            browse={page.browse}
                            loading={page.loadingMore}
                        />
                    ) : null}

                    {page.step === "form" ? (
                        <BookingForm
                            booker={page.form.booker}
                            filter={page.form.filter}
                            campaigns={page.form.campaigns}
                            platforms={page.form.platforms}
                            reactHookForm={page.form.reactHookForm}
                            salesTeam={page.form.salesTeam}
                        />
                    ) : null}

                    {page.step === "confirmation" ? (
                        <>
                            {page.confirmation.status === undefined ? (
                                <div className="mt-12 mb-12 text-center">
                                    <Loader2 className="mx-auto size-8 animate-spin text-primary" aria-label="Loading" />
                                </div>
                            ) : null}
                        </>
                    ) : null}

                    {page.confirmation.status?.success === true ? (<>
                        {page.confirmation.isManager ? (
                            <div className="text-center">
                                <Heading type="h2" className="mt-12 mb-4">All set!</Heading>
                                <div className="mb-4">Your booking is saved.</div>
                                <div className="mt-4"><TextLink href="/">Return to dashboard...</TextLink></div>
                                <div className="mt-12"><TextLink href="/new-booking">Start another booking...</TextLink></div>
                            </div>
                        ) : (
                            <div className="text-center">
                                <Heading type="h2" className="mt-12 mb-4">Thank You!</Heading>
                                <div className="mb-4">We&apos;ll be in touch soon!</div>
                                <div className="mt-12"><TextLink href="/">Start another booking...</TextLink></div>
                            </div>
                        )}
                    </>
                    ) : null}

                    {page.confirmation.status?.success === false ? (
                        <div className="mt-12 mb-12 text-center">An Error Occurred. Please try again.</div>
                    ) : null}
                </div>

                <div className="sticky top-0 hidden h-[calc(100vh-5rem)] flex-[0_0_30%] overflow-auto border-l border-border bg-white p-4 lg:block">
                    <BookingSummary
                        talent={page.summary.talent}
                        selectedTalent={page.summary.selectedTalent}
                        userCurrency={page.summary.userCurrency}
                        totalPrice={page.summary.totalPrice}
                        totalTiktokFollowers={page.summary.totalTiktokFollowers}
                        totalInstagramFollowers={page.summary.totalInstagramFollowers}
                        handleRemove={page.summary.handleRemove}
                    />
                </div>

                <div className={`fixed inset-0 z-10 h-screen bg-white p-4 pb-20 lg:hidden${page.summary.showMobileSummary ? "" : " hidden"}`}>
                    <div className="h-[calc(100vh-6rem)] overflow-y-auto">
                        <BookingSummary
                            talent={page.summary.talent}
                            selectedTalent={page.summary.selectedTalent}
                            userCurrency={page.summary.userCurrency}
                            totalPrice={page.summary.totalPrice}
                            totalTiktokFollowers={page.summary.totalTiktokFollowers}
                            totalInstagramFollowers={page.summary.totalInstagramFollowers}
                            handleRemove={page.summary.handleRemove}
                        />
                    </div>
                </div>

                <form onSubmit={page.form.onSubmit}>
                    {page.step !== "confirmation" ? (
                        <BookingNavigation {...page.nav} />
                    ) : null}
                </form>
            </div>
        </Layout>
    );
}
